import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import EGDatePicker from "../../../../../MainComponents/DatePicker/EGDatePicker";
import { ConfirmationContainer } from "../../../../../Modal/Confirmation/Confirmation";
import { InvestigationButton } from "../../components";

export const Conclude = ({
  show,
  onHide,
  onConfirm,
  defaultDate,
  loading = false,
}) => {
  const [t] = useTranslation("investigation");

  const [conclusion_at, setConclusion_at] = useState(
    dayjs(defaultDate).isValid() ? dayjs(defaultDate) : dayjs(),
  );

  // Al abrir: usa la fecha ya establecida o, en su defecto, hoy
  useEffect(() => {
    if (show) {
      setConclusion_at(
        dayjs(defaultDate).isValid() ? dayjs(defaultDate) : dayjs(),
      );
    }
  }, [show]);

  // Guarda primero; si falla, el modal queda abierto
  const handleConfirm = async () => {
    try {
      await onConfirm(conclusion_at.toDate());
      onHide();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ConfirmationContainer
      show={show}
      onHide={onHide}
      variant="error"
      ethiquin="investigation"
      sx={{ p: 2 }}
    >
      <Typography
        fontSize={28}
        fontWeight={700}
        color="pink.main"
        textAlign="start"
      >
        {t("Conclusion.conclude_modal_title")}
      </Typography>
      <Typography
        component="p"
        color="oxfordBlue.main"
        mt={2}
        textAlign="start"
      >
        {t("Conclusion.conclude_modal_description")}
      </Typography>
      <Typography
        component="p"
        color="oxfordBlue2.main"
        mt={1}
        mb={2}
        textAlign="start"
      >
        {t("Conclusion.conclude_modal_description2")}
      </Typography>
      <EGDatePicker
        label={t("Conclusion.conclude_modal_date")}
        value={conclusion_at}
        onChange={setConclusion_at}
        minDate={dayjs()}
      />
      <Typography
        color="primary.main"
        mt={1.5}
        mb={3.5}
        textAlign="start"
        fontSize={16}
        fontWeight={600}
      >
        {t("Conclusion.conclude_modal_confirm")}
      </Typography>
      <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
        <InvestigationButton
          label={t("Conclusion.confirm")}
          onClick={handleConfirm}
          icon={false}
          variant="success"
          size="medium"
          loading={loading}
        />
        <InvestigationButton
          label={t("Conclusion.cancel")}
          onClick={onHide}
          icon={false}
          variant="secondary"
          size="medium"
          outlined
          disabled={loading}
        />
      </Stack>
    </ConfirmationContainer>
  );
};
